import { GridColDef, GridRowModel } from "@mui/x-data-grid"
import { Header, TableStandard } from "ui"
import { useEffect, useState } from "react"
import { CompanySessionStats } from "../../../../__generated__/graphql"
const TABLE_COLUMNS: GridColDef[] = [
    { field: "question", headerName: "Question", flex: 3, sortable: false, resizable: false, disableColumnMenu: true, },
    { field: "count", headerName: "Count", headerAlign: "center", align: "center", flex: 1, sortable: false, resizable: false, disableColumnMenu: true, },
]
type DispositionKey = keyof CompanySessionStats;
const allowedFields: DispositionKey[] = ["inTherapy", "hasRecentDeath", "beenBullied"]
const mappedQuestions = {
    "inTherapy": "Reported in Therapy",
    "hasRecentDeath": "Reported Recent Death",
    "beenBullied": "Reporting having a friend/peer that made them feel bad",
} as const
const ImportantQuestionTable = ({ questionStats }: { questionStats: CompanySessionStats | null }) => {
    const [pageTableState, setPageTableState] = useState<{
        columns: GridColDef[],
        rows: GridRowModel[],
        filteredRows: GridRowModel[]
        status: "NORMAL" | "FILTERING"
    }>({
        columns: [],
        rows: [],
        filteredRows: [],
        status: "NORMAL"
    })
    useEffect(() => {
        setPageTableState((prevState) => {
            const columns = [...TABLE_COLUMNS]
            const rows = questionStats
                ? allowedFields.map(key => ({
                    id: key,
                    question: mappedQuestions[key as keyof typeof mappedQuestions],
                    count: questionStats[key]
                }))
                : [];

            return {
                ...prevState,
                columns,
                rows: rows
            }
        })
    }, [questionStats])
    return (
        <TableStandard
            renderToolbar={() => (
                <Header title={`Questions`} titleSize="p" />
            )}
            autoHeight
            columns={pageTableState.columns}
            rows={pageTableState.rows}
            disableBoxShadow
            hideFooter={true}
            loading={false} />
    )
}
export default ImportantQuestionTable